import { Cloud } from '@cast/shared-types';

export const ANYWHERE_PROVIDER = 'anywhere' as const;

export type ScriptMethodProvider = Cloud | typeof ANYWHERE_PROVIDER;
